export const environment = {
    production: false,
    config: {
        appName: 'Primăria Sectorului 4',
        appDescription: 'DGASPC S4',
        fromTokenValid: 'https://development.auth-core.webproductionlabs.com/api/login',
        tokenKey: 'wpl-staging-operator-app-token', // this token is used for every request where is needed
        userKey: 'wpl-staging-operator-app-user', // here we find local storage with minimal user data
        storageKey: 'wpl-staging-operator', // here we find key for predefined local storage for app functionalities
        copyrightText: 'Copyright © Direcția Generală de Asistență Socială și Protecția Copilului Sector 4 - 2025',
        defaultLNG: 'ro',
        emailRegex:
            '^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$',
        codeSMSRegex: /^[0-9]+$/,
        phoneRegex: '[0-9]{6,20}',
        cnpRegex: '[0-9]{13,13}',
        validatorsAccrossApp: {
            minPassword: 8,
            maxPassword: 30,
            emailMaxLength: 50,
            minStringLength: 2,
            maxStringLength: 60,
            minSmsCodeLength: 1,
            maxSmsCodeLength: 1,
        },
        customNotifications: {
            icons: {
                success: 'success',
                error: 'error',
                info: 'info',
                warning: 'warning',
            },
            headers: {
                success: 'Succes',
                error: 'Eroare',
                successForm: 'Felicitări!',
            },
            generalMessages: {
                error:
                    'Ne pare rău, dar am întampinat o problemă. Vă rugăm să reîncercați. Dacă problema persistă, vă rugăm să ne contactați prin butonul de suport IT.',
            },
        },
        romanianLanguageDataTable: {
            sEmptyTable: 'Niciun rezultat găsit',
            sInfo: 'Afișate de la _START_ până la _END_ din _TOTAL_ înregistrări',
            sInfoEmpty: 'Afișate de la 0 până la 0 din 0 înregistrări',
            sInfoFiltered: '(filtrat din _TOTAL_ înregistrări)',
            sInfoPostFix: '',
            sInfoThousands: ',',
            sLengthMenu: 'Afișează _MENU_ înregistrări pe pagină',
            sLoadingRecords: 'Încărcare...',
            sProcessing: 'Procesare...',
            sSearch: 'Caută:',
            sZeroRecords: 'Niciun rezultat găsit',
            oPaginate: {
                sFirst: 'Prima',
                sLast: 'Ultima',
                sNext: 'Următoarea',
                sPrevious: 'Anterioară',
            },
            oAria: {
                sSortAscending: ': activează pentru a sorta coloana crescător',
                sSortDescending: ': activează pentru a sorta coloana descrescător',
            },
        },
    },
    interop: {
        basePath: 'https://development.dgaspc-core.webproductionlabs.com/',
        clientId: 10,
        moduleId: 11,
        dgaspcId: 22,
        dgaspc: {
            authorizeShortToken: 'authorization_code/',
            notifications: {
                authNotifications: 'api/cerere/auth-notifications',
            },
            tari: {
                getTari: 'api/settings/address/countries/search',
                getTariActive: 'api/settings/address/countries/active/search',
                getTariPublic: 'api/settings/address/countries/public/search',
            },
            judete: {
                getJudete: 'api/settings/address/judete/search',
                getJudeteActive: 'api/settings/address/judete/active/search',
                getJudetePublic: 'api/settings/address/judete/public/search',
            },
            localitati: {
                getLocalitati: 'api/settings/address/localitati/search',
                getLocalitatiActive: 'api/settings/address/localitati/active/search',
                getLocalitatiPublic: 'api/settings/address/localitati/public/search',
            },
            strazi: {
                getStrazi: 'api/settings/address/strazi/search',
                getStraziActive: 'api/settings/address/strazi/active/search',
                getStraziPublic: 'api/settings/address/strazi/public/search',
                storeStrada: 'api/registratura/strada/store',
            },
            cerere: {
                getCereriList: 'api/cerere/list',
                getCereriListDT: 'api/cerere/list-dt',
                findCerere: 'api/cerere/find/', // + id
                storeCereri: 'api/cerere/store',
                updateCereri: 'api/cerere/update',
                deleteCereri: 'api/cerere/delete/', // + id
                getInfoDocList: 'api/cerere/getInformationsDocumentsList/', // + id
                updateStatus: 'api/cerere/update-status/', // + id
                updatePriority: 'api/cerere/update-priority/', // + id
                updateAssignee: 'api/cerere/update-asignee/', // + id

                postMessage: 'api/cerere/post-message/', // + id
                rePostMessage: 'api/cerere/re-post-message/', // + id

                downloadDocument: 'api/cerere/download-document/', // + id
                downloadDocumentAnexa: 'api/cerere/download-document-anexa/', // + id

                downloadManual: 'api/cerere/manual',

                preluarePersonala: 'api/cerere/preluare-cerere/', // + id
                preluareNumarRegistratura: 'api/cerere/generate-reg-number/', // + id
                validateCerere: 'api/cerere/validate/', // + id
                invalidateCerere: 'api/cerere/invalidate/', // + id
                anulareCerere: 'api/cerere/anulare/', // + id
                finalizareCerere: 'api/cerere/finalize-cerere/', // + id

                editValabilitateDocGenerabil: 'api/cerere/edit-document-valability/', // + id

                massAssign: 'api/cerere/update-mass-asignee', // id in payload
                massUpdateStatus: 'api/cerere/update-mass-status',

                file: {
                    fileUpload: 'api/cerere/upload-file',
                    fileUploadBase64: 'api/cerere/upload-file-base64',
                    tempFileDownload: 'api/cerere/temp-file-download',
                },

                uploadOnlineDocument: 'api/cerere/upload-online-document/', // id cerere

                // special operations
                generateDocument: 'api/cerere/generare-document/', // id => id_cerere, templateId => templateId
                validateDocument: 'api/cerere/validate-document/', // id
                validateDocumentSuperior: 'api/cerere-validate-superior/', // id => id_cerere, documentId => documentId
                cancelDocumentSuperior: 'api/cerere-anulare-superior/', // id => documentId
                // validateDocumentByUpload: 'api/cerere/validate-document/', // id document
                generareDraft: 'api/cerere/precompletare/',
                resetDocumentValidated: 'api/cerere/reset-document/', // id document
                resetDocumentIntocmitorValidated:
                    'api/cerere/reset-document-intocmitor/', // id document
                uploadedFinalDocument: 'api/cerere/upload-document-oficial/', // id document
                addToRegistru: 'api/cerere-registru-add/', // cerereId, documentId
                downloadDocumentOfficial: 'api/cerere/download-document-oficial/', // id document
                downloadDocumentGenerat: 'api/cerere/download-document-generat/', // id document
                downloadDocumentSigned: 'api/cerere/download-document-signed/', // id => documentId
                downloadDocumentSignatureSigned:
                    'api/cerere/download-document-signature-signed/', // id => signatureId
                istoricDocument: 'api/cerere/istoric-document/', // id document
                destroyDocument: 'api/cerere/destroy-document/', // id document
                updateDocument: 'api/cerere/update-document/', // id document
                downloadTableSignatures: 'api/cerere/download-approval-table/', // id document

                sendDocumentToIntocmitor: 'api/cerere/send-document-back/', // id => signatureId
                sendDocumentForwardIntocmitor: 'api/cerere/send-document-forward/', // id => documentId
                sendDocumentForwardToSigner:
                    'api/cerere/send-document-forward-superior/', // id => signatureId

                rsyncSignaturesDocumentGenerat: 'api/cerere/reload-document-flow/', // id _ documentId

                exportHistory: 'api/cerere/download-history/', //+ id_cerere + user type (2=> ceteatan, 1=> operator)

                resetValidareCerere: 'api/cerere/reset/validare/', // id_cerere - PUT
                resetinValidareCerere: 'api/cerere/reset/invalidare/', // id_cerere - PUT
                resetClasareCerere: 'api/cerere/reset/clasare/', // id_cerere - PUT
                resetInchidereCerere: 'api/cerere/reset/finalizare/', // id_cerere - POST

                sendNotificationCetateanDocumentOficial:
                    'api/cerere/send-document-oficial-notificare-cetatean/', // id document generat - GET request

                resetDocumentOficialNotificareCetatean:
                    'api/cerere/reset-document-oficial-notificare-cetatean/', // + id
                resetUploadDocumentOfficial:
                    'api/cerere/reset-upload-document-official/', // + id

                cerereUpdateMetadate: 'api/cerere/update-metadate/', // + id cerere

                setDocTypeForDocument: 'api/cerere/document-generat/manually-doc-type/', // + id document generat
                updateCurrentSignatureDocument: 'api/cerere/document-generat/manually-update-user-validation/', // + id document generat

                signatures: {
                    getListIds:
                        'api/cerere/document-generat/signatures/allocated/', // + id document + doc_type
                    updateIds:
                        'api/cerere/document-generat/signatures/allocated/', // + id document
                    // updateOrder:
                    // 	'api/nomenclatoare/document-templates/signatures/update-order/', // + id signature
                    // updateSignType:
                    // 	'api/nomenclatoare/document-templates/signatures/update-sign-type/', // + id
                    updateSignatures:
                        'api/cerere/document-generat/signatures/update-signatures',
                },

                allowMessages: 'api/cerere/allow-messages/', // + id
            },
            confirmareDocumente: {
                getDocumenteCofirmareDT: 'api/confirmari/list-dt',
                fileDownload: 'api/confirmari/download/', // + id
                predareDocumente: 'api/confirmari/predare-documente-sediu', // id[] in payload
                printDocumente: 'api/confirmari/print-documente-confirmate',
                printDocumenteIstoric: 'api/confirmari/print-documente-confirmate-istoric/', // + id
            },
            notificari: {
                email: {
                    getEmailDt: 'api/email/list-dt',
                    downloadEmail: 'api/email/view/', // + id
                    resendEmail: 'api/email/resend/', // + id
                    printNotificari: 'api/email/print',
                },
                sms: {
                    getSMSDt: 'api/sms/list-dt',
                    resendSMS: 'api/sms/resend/', // + id
                    printNotificari: 'api/sms/print',
                }
            },
            activitati: {
                contracteProgramari: {
                    listDT: 'api/activitati/contract/list-dt',
                    findContract: 'api/activitati/contract/find/',
                    postMessage: 'api/activitati/entities/post-message/',
                    exportHistory: 'api/activitati/contract/download-history/',
                    updatePrezenta: 'api/activitati/entities/programare/', // + idProgramare + "status"
                    printContract: 'api/activitati/contract/download-contract/',
                    exportCSV: 'api/activitati/contract/export-list-dt/?format=csv',
                    reziliereContract: 'api/activitati/contract/', // + idContract + "status"
                },
                inregistrareProgramare: {
                    findEntitate: 'api/activitati/entities/find-advanced',
                    listContracte: 'api/activitati/contract/list',
                    createContract: 'api/activitati/contract/store',
                    getSlots: 'api/activitati/contract/available-slots',
                    updateSlots: 'api/activitati/contract/update-slots',
                    storeSubcontract: 'api/activitati/contract/store-subcontract',
                    updateSubcontract: 'api/activitati/contract/update-subcontract/',
                    deleteSubcontract: 'api/activitati/contract/delete-subcontract/',
                    finalizare: 'api/activitati/contract/finalizare/',
                    deleteContract: 'api/activitati/contract/delete/',
                },
                copii: {
                    getCopil: 'api/activitati/entities/find/', // + id
                    getCopii: 'api/activitati/entities/list',
                    getCopiiDT: 'api/activitati/entities/list-dt',
                    updateCopil: 'api/activitati/entities/update', // id in payload
                    deleteCopil: 'api/activitati/entities/delete/', // + id
                    storeCopil: 'api/activitati/entities/store/',

                    storeLocalizare: 'api/activitati/entities/store/localizare/', // + id entitate
                    updateLocalizare: 'api/activitati/entities/update/localizare/', // + id localizare
                    deleteLocalizare: 'api/activitati/entities/delete/localizare/', // + id localizare
                    storeRelatie: 'api/activitati/entities/store/relatie/', // + id entitate
                    updateRelatie: 'api/activitati/entities/update/relatie/', // + id relatie
                    deleteRelatie: 'api/activitati/entities/delete/relatie/', // + id relatie
                    storeFiles: 'api/activitati/entities/store/files/', // + id entitate
                    updateFiles: 'api/activitati/entities/update/files/', // + id entitate/id group_file
                    downloadFile: 'api/activitati/entities/download/file/', // + id fisier
                    downloadChanges: 'api/activitati/entities/download-changes/', // + {type}/{id}/{entityId}
                    downloadFisa: 'api/activitati/entities/download-fisa/', // + entityId

                    postMessage: 'api/activitati/entities/post-message/', // + id entitate
                    downloadHistory: 'api/activitati/entities/download-history/', // + id entitate/id type

                    internalSearch: 'api/activitati/entities/internal/search/', // + id indoc
                },
                scans: {
                    getScan: 'api/activitati/documents/find-document/', // + id
                    getScans: 'api/activitati/documents/list',
                    getScansDT: 'api/activitati/documents/list-dt',
                    updateScan: 'api/activitati/documents/update', // id in payload
                    deleteScan: 'api/activitati/documents/delete/', // + id
                    storeScan: 'api/activitati/documents/store',
                    downloadScan: 'api/activitati/documents/download-file/', // + id
                    updateEntity: 'api/activitati/documents/update-document-entity',
                    storeGroup: 'api/activitati/documents/store-group',
                    storeGroupMetadata: 'api/activitati/documents/store-group-data',
                    updateGroup: 'api/activitati/documents/update-group', // id in payload
                    deleteGroup: 'api/activitati/documents/delete-group/', // + id
                    updatePriority: 'api/activitati/documents/update-document-priority',
                    updateStatus: 'api/activitati/documents/update-document-status',
                    updateAssignee: 'api/activitati/documents/update-document-assignee',
                    updateDocumentName: 'api/activitati/documents/update-document-name',
                    finalizeGroup: 'api/activitati/documents/finalize-group/', // + id
                    resetFinalizeGroup: 'api/activitati/documents/unset-group-finalized/', // + id
                },
                fileUpload: 'api/activitati/upload-file-register',
                fileUploadBase64: 'api/activitati/upload-file-register-base64',
                tempFileDownload: 'api/activitati/temp-file-download',
                nomenclatoare: {
                    situatieCurentaCopil: {
                        list: 'api/activitati/nomenclator/case-types/list',
                        listDT: 'api/activitati/nomenclator/case-types/list-dt',
                        listActive: 'api/activitati/nomenclator/case-types/list-active',
                        listPublic: 'api/activitati/nomenclator/case-types/list-public',
                        find: 'api/activitati/nomenclator/case-types/find/', // + id
                        store: 'api/activitati/nomenclator/case-types/store',
                        update: 'api/activitati/nomenclator/case-types/update',  // id in payload
                        delete: 'api/activitati/nomenclator/case-types/delete/', // + id
                        active: 'api/activitati/nomenclator/case-types/toggle-active/', // + id
                        public: 'api/activitati/nomenclator/case-types/toggle-public/', // + id
                    },
                    grupAtributeCopii: {  // Group Atribute Copii
                        list: 'api/activitati/nomenclator/entities-attribute-groups/list',
                        listDT: 'api/activitati/nomenclator/entities-attribute-groups/list-dt',
                        listActive: 'api/activitati/nomenclator/entities-attribute-groups/list-active',
                        listPublic: 'api/activitati/nomenclator/entities-attribute-groups/list-public',
                        find: 'api/activitati/nomenclator/entities-attribute-groups/find/', // + id
                        store: 'api/activitati/nomenclator/entities-attribute-groups/store',
                        update: 'api/activitati/nomenclator/entities-attribute-groups/update',  // id in payload
                        delete: 'api/activitati/nomenclator/entities-attribute-groups/delete/', // + id
                        active: 'api/activitati/nomenclator/entities-attribute-groups/toggle-active/', // + id
                        public: 'api/activitati/nomenclator/entities-attribute-groups/toggle-public/', // + id
                    },
                    atributeCopii: { // Atribute Copii, based on groups
                        list: 'api/activitati/nomenclator/entities-attribute-nomenclator/list',
                        listDT: 'api/activitati/nomenclator/entities-attribute-nomenclator/list-dt',
                        listActive: 'api/activitati/nomenclator/entities-attribute-nomenclator/list-active',
                        listPublic: 'api/activitati/nomenclator/entities-attribute-nomenclator/list-public',
                        listByGroup: 'api/activitati/nomenclator/entities-attribute-nomenclator/list-by-group/', // + id
                        find: 'api/activitati/nomenclator/entities-attribute-nomenclator/find/', // + id
                        store: 'api/activitati/nomenclator/entities-attribute-nomenclator/store',
                        update: 'api/activitati/nomenclator/entities-attribute-nomenclator/update',  // id in payload
                        delete: 'api/activitati/nomenclator/entities-attribute-nomenclator/delete/', // + id
                        active: 'api/activitati/nomenclator/entities-attribute-nomenclator/toggle-active/', // + id
                        public: 'api/activitati/nomenclator/entities-attribute-nomenclator/toggle-public/', // + id
                    },
                    tipuriDateCopii: {
                        list: 'api/activitati/nomenclator/entities-data-types/list',
                        listDT: 'api/activitati/nomenclator/entities-data-types/list-dt',
                        listActive: 'api/activitati/nomenclator/entities-data-types/list-active',
                        find: 'api/activitati/nomenclator/entities-data-types/find/', // + id
                        store: 'api/activitati/nomenclator/entities-data-types/store',
                        update: 'api/activitati/nomenclator/entities-data-types/update',  // id in payload
                        delete: 'api/activitati/nomenclator/entities-data-types/delete/', // + id
                        active: 'api/activitati/nomenclator/entities-data-types/toggle-active/', // + id
                    },
                    statusEvenimentCopil: {
                        list: 'api/activitati/nomenclator/events-statuses/list',
                        listDT: 'api/activitati/nomenclator/events-statuses/list-dt',
                        listActive: 'api/activitati/nomenclator/events-statuses/list-active',
                        listPublic: 'api/activitati/nomenclator/events-statuses/list-public',
                        find: 'api/activitati/nomenclator/events-statuses/find/', // + id
                        store: 'api/activitati/nomenclator/events-statuses/store',
                        update: 'api/activitati/nomenclator/events-statuses/update',  // id in payload
                        delete: 'api/activitati/nomenclator/events-statuses/delete/', // + id
                        active: 'api/activitati/nomenclator/events-statuses/toggle-active/', // + id
                        public: 'api/activitati/nomenclator/events-statuses/toggle-public/', // + id
                    },
                    prioritateEvenimentCopil: {
                        list: 'api/activitati/nomenclator/events-priorities/list',
                        listDT: 'api/activitati/nomenclator/events-priorities/list-dt',
                        listActive: 'api/activitati/nomenclator/events-priorities/list-active',
                        listPublic: 'api/activitati/nomenclator/events-priorities/list-public',
                        find: 'api/activitati/nomenclator/events-priorities/find/', // + id
                        store: 'api/activitati/nomenclator/events-priorities/store',
                        update: 'api/activitati/nomenclator/events-priorities/update',  // id in payload
                        delete: 'api/activitati/nomenclator/events-priorities/delete/', // + id
                        active: 'api/activitati/nomenclator/events-priorities/toggle-active/', // + id
                        public: 'api/activitati/nomenclator/events-priorities/toggle-public/', // + id
                    },
                    entitateInruditaType: {
                        list: 'api/activitati/nomenclator/entities-related-types/list',
                        listDT: 'api/activitati/nomenclator/entities-related-types/list-dt',
                        listActive: 'api/activitati/nomenclator/entities-related-types/list-active',
                        listPublic: 'api/activitati/nomenclator/entities-related-types/list-public',
                        find: 'api/activitati/nomenclator/entities-related-types/find/', // + id
                        store: 'api/activitati/nomenclator/entities-related-types/store',
                        update: 'api/activitati/nomenclator/entities-related-types/update',  // id in payload
                        delete: 'api/activitati/nomenclator/entities-related-types/delete/', // + id
                        active: 'api/activitati/nomenclator/entities-related-types/toggle-active/', // + id
                        public: 'api/activitati/nomenclator/entities-related-types/toggle-public/', // + id
                    },
                    relatieType: {
                        list: 'api/activitati/nomenclator/entities-relationship-types/list',
                        listDT: 'api/activitati/nomenclator/entities-relationship-types/list-dt',
                        listActive: 'api/activitati/nomenclator/entities-relationship-types/list-active',
                        listPublic: 'api/activitati/nomenclator/entities-relationship-types/list-public',
                        find: 'api/activitati/nomenclator/entities-relationship-types/find/', // + id
                        store: 'api/activitati/nomenclator/entities-relationship-types/store',
                        update: 'api/activitati/nomenclator/entities-relationship-types/update',  // id in payload
                        delete: 'api/activitati/nomenclator/entities-relationship-types/delete/', // + id
                        active: 'api/activitati/nomenclator/entities-relationship-types/toggle-active/', // + id
                        public: 'api/activitati/nomenclator/entities-relationship-types/toggle-public/', // + id
                    },
                    custodieType: {
                        list: 'api/activitati/nomenclator/custody-types/list',
                        listDT: 'api/activitati/nomenclator/custody-types/list-dt',
                        listActive: 'api/activitati/nomenclator/custody-types/list-active',
                        listPublic: 'api/activitati/nomenclator/custody-types/list-public',
                        find: 'api/activitati/nomenclator/custody-types/find/', // + id
                        store: 'api/activitati/nomenclator/custody-types/store',
                        update: 'api/activitati/nomenclator/custody-types/update',  // id in payload
                        delete: 'api/activitati/nomenclator/custody-types/delete/', // + id
                        active: 'api/activitati/nomenclator/custody-types/toggle-active/', // + id
                        public: 'api/activitati/nomenclator/custody-types/toggle-public/', // + id
                    },
                    relatieStatus: {
                        list: 'api/activitati/nomenclator/entities-relationship-status/list',
                        listDT: 'api/activitati/nomenclator/entities-relationship-status/list-dt',
                        listActive: 'api/activitati/nomenclator/entities-relationship-status/list-active',
                        listPublic: 'api/activitati/nomenclator/entities-relationship-status/list-public',
                        find: 'api/activitati/nomenclator/entities-relationship-status/find/', // + id
                        store: 'api/activitati/nomenclator/entities-relationship-status/store',
                        update: 'api/activitati/nomenclator/entities-relationship-status/update',  // id in payload
                        delete: 'api/activitati/nomenclator/entities-relationship-status/delete/', // + id
                        active: 'api/activitati/nomenclator/entities-relationship-status/toggle-active/', // + id
                        public: 'api/activitati/nomenclator/entities-relationship-status/toggle-public/', // + id
                    },
                    capacitateCrestereCopil: {
                        list: 'api/activitati/nomenclator/parent-child-rearing-capacities/list',
                        listDT: 'api/activitati/nomenclator/parent-child-rearing-capacities/list-dt',
                        listActive: 'api/activitati/nomenclator/parent-child-rearing-capacities/list-active',
                        listPublic: 'api/activitati/nomenclator/parent-child-rearing-capacities/list-public',
                        find: 'api/activitati/nomenclator/parent-child-rearing-capacities/find/', // + id
                        store: 'api/activitati/nomenclator/parent-child-rearing-capacities/store',
                        update: 'api/activitati/nomenclator/parent-child-rearing-capacities/update',  // id in payload
                        delete: 'api/activitati/nomenclator/parent-child-rearing-capacities/delete/', // + id
                        active: 'api/activitati/nomenclator/parent-child-rearing-capacities/toggle-active/', // + id
                        public: 'api/activitati/nomenclator/parent-child-rearing-capacities/toggle-public/', // + id
                    },
                    nivelRisc: {
                        list: 'api/activitati/nomenclator/risk-levels/list',
                        listDT: 'api/activitati/nomenclator/risk-levels/list-dt',
                        listActive: 'api/activitati/nomenclator/risk-levels/list-active',
                        listPublic: 'api/activitati/nomenclator/risk-levels/list-public',
                        find: 'api/activitati/nomenclator/risk-levels/find/', // + id
                        store: 'api/activitati/nomenclator/risk-levels/store',
                        update: 'api/activitati/nomenclator/risk-levels/update',  // id in payload
                        delete: 'api/activitati/nomenclator/risk-levels/delete/', // + id
                        active: 'api/activitati/nomenclator/risk-levels/toggle-active/', // + id
                        public: 'api/activitati/nomenclator/risk-levels/toggle-public/', // + id
                    },
                    statusLegal: {
                        list: 'api/activitati/nomenclator/legal-statuses/list',
                        listDT: 'api/activitati/nomenclator/legal-statuses/list-dt',
                        listActive: 'api/activitati/nomenclator/legal-statuses/list-active',
                        listPublic: 'api/activitati/nomenclator/legal-statuses/list-public',
                        find: 'api/activitati/nomenclator/legal-statuses/find/', // + id
                        store: 'api/activitati/nomenclator/legal-statuses/store',
                        update: 'api/activitati/nomenclator/legal-statuses/update',  // id in payload
                        delete: 'api/activitati/nomenclator/legal-statuses/delete/', // + id
                        active: 'api/activitati/nomenclator/legal-statuses/toggle-active/', // + id
                        public: 'api/activitati/nomenclator/legal-statuses/toggle-public/', // + id
                    },
                    contactFrecventa: {
                        list: 'api/activitati/nomenclator/contact-frequency/list',
                        listDT: 'api/activitati/nomenclator/contact-frequency/list-dt',
                        listActive: 'api/activitati/nomenclator/contact-frequency/list-active',
                        listPublic: 'api/activitati/nomenclator/contact-frequency/list-public',
                        find: 'api/activitati/nomenclator/contact-frequency/find/', // + id
                        store: 'api/activitati/nomenclator/contact-frequency/store',
                        update: 'api/activitati/nomenclator/contact-frequency/update',  // id in payload
                        delete: 'api/activitati/nomenclator/contact-frequency/delete/', // + id
                        active: 'api/activitati/nomenclator/contact-frequency/toggle-active/', // + id
                        public: 'api/activitati/nomenclator/contact-frequency/toggle-public/', // + id
                    },
                    parteaRelatiei: {
                        list: 'api/activitati/nomenclator/relationship-sides/list',
                        listDT: 'api/activitati/nomenclator/relationship-sides/list-dt',
                        listActive: 'api/activitati/nomenclator/relationship-sides/list-active',
                        listPublic: 'api/activitati/nomenclator/relationship-sides/list-public',
                        find: 'api/activitati/nomenclator/relationship-sides/find/', // + id
                        store: 'api/activitati/nomenclator/relationship-sides/store',
                        update: 'api/activitati/nomenclator/relationship-sides/update',  // id in payload
                        delete: 'api/activitati/nomenclator/relationship-sides/delete/', // + id
                        active: 'api/activitati/nomenclator/relationship-sides/toggle-active/', // + id
                        public: 'api/activitati/nomenclator/relationship-sides/toggle-public/', // + id
                    },
                    relatieSpecificaGen: {
                        list: 'api/activitati/nomenclator/gender-specific-relation/list',
                        listDT: 'api/activitati/nomenclator/gender-specific-relation/list-dt',
                        listActive: 'api/activitati/nomenclator/gender-specific-relation/list-active',
                        listPublic: 'api/activitati/nomenclator/gender-specific-relation/list-public',
                        find: 'api/activitati/nomenclator/gender-specific-relation/find/', // + id
                        store: 'api/activitati/nomenclator/gender-specific-relation/store',
                        update: 'api/activitati/nomenclator/gender-specific-relation/update',  // id in payload
                        delete: 'api/activitati/nomenclator/gender-specific-relation/delete/', // + id
                        active: 'api/activitati/nomenclator/gender-specific-relation/toggle-active/', // + id
                        public: 'api/activitati/nomenclator/gender-specific-relation/toggle-public/', // + id
                    },
                    confirmareRelatie: {
                        list: 'api/activitati/nomenclator/relationship-status/list',
                        listDT: 'api/activitati/nomenclator/relationship-status/list-dt',
                        listActive: 'api/activitati/nomenclator/relationship-status/list-active',
                        listPublic: 'api/activitati/nomenclator/relationship-status/list-public',
                        find: 'api/activitati/nomenclator/relationship-status/find/', // + id
                        store: 'api/activitati/nomenclator/relationship-status/store',
                        update: 'api/activitati/nomenclator/relationship-status/update',  // id in payload
                        delete: 'api/activitati/nomenclator/relationship-status/delete/', // + id
                        active: 'api/activitati/nomenclator/relationship-status/toggle-active/', // + id
                        public: 'api/activitati/nomenclator/relationship-status/toggle-public/', // + id
                    },
                    evenimentGenealogicType: {
                        list: 'api/activitati/nomenclator/genealogical-event-types/list',
                        listDT: 'api/activitati/nomenclator/genealogical-event-types/list-dt',
                        listActive: 'api/activitati/nomenclator/genealogical-event-types/list-active',
                        listPublic: 'api/activitati/nomenclator/genealogical-event-types/list-public',
                        find: 'api/activitati/nomenclator/genealogical-event-types/find/', // + id
                        store: 'api/activitati/nomenclator/genealogical-event-types/store',
                        update: 'api/activitati/nomenclator/genealogical-event-types/update',  // id in payload
                        delete: 'api/activitati/nomenclator/genealogical-event-types/delete/', // + id
                        active: 'api/activitati/nomenclator/genealogical-event-types/toggle-active/', // + id
                        public: 'api/activitati/nomenclator/genealogical-event-types/toggle-public/', // + id
                    },
                    conditieMedicalaType: {
                        list: 'api/activitati/nomenclator/medical-condition-types/list',
                        listDT: 'api/activitati/nomenclator/medical-condition-types/list-dt',
                        listActive: 'api/activitati/nomenclator/medical-condition-types/list-active',
                        listPublic: 'api/activitati/nomenclator/medical-condition-types/list-public',
                        find: 'api/activitati/nomenclator/medical-condition-types/find/', // + id
                        store: 'api/activitati/nomenclator/medical-condition-types/store',
                        update: 'api/activitati/nomenclator/medical-condition-types/update',  // id in payload
                        delete: 'api/activitati/nomenclator/medical-condition-types/delete/', // + id
                        active: 'api/activitati/nomenclator/medical-condition-types/toggle-active/', // + id
                        public: 'api/activitati/nomenclator/medical-condition-types/toggle-public/', // + id
                    },
                    documentStatuses: {
                        list: 'api/activitati/nomenclator/document-statuses/list',
                        listDT: 'api/activitati/nomenclator/document-statuses/list-dt',
                        listActive: 'api/activitati/nomenclator/document-statuses/list-active',
                        listPublic: 'api/activitati/nomenclator/document-statuses/list-public',
                        find: 'api/activitati/nomenclator/document-statuses/find/', // + id
                        store: 'api/activitati/nomenclator/document-statuses/store',
                        update: 'api/activitati/nomenclator/document-statuses/update',  // id in payload
                        delete: 'api/activitati/nomenclator/document-statuses/delete/', // + id
                        active: 'api/activitati/nomenclator/document-statuses/toggle-active/', // + id
                        public: 'api/activitati/nomenclator/document-statuses/toggle-public/', // + id
                    },
                    documentPriorities: {
                        list: 'api/activitati/nomenclator/document-priorities/list',
                        listDT: 'api/activitati/nomenclator/document-priorities/list-dt',
                        listActive: 'api/activitati/nomenclator/document-priorities/list-active',
                        listPublic: 'api/activitati/nomenclator/document-priorities/list-public',
                        find: 'api/activitati/nomenclator/document-priorities/find/', // + id
                        store: 'api/activitati/nomenclator/document-priorities/store',
                        update: 'api/activitati/nomenclator/document-priorities/update',  // id in payload
                        delete: 'api/activitati/nomenclator/document-priorities/delete/', // + id
                        active: 'api/activitati/nomenclator/document-priorities/toggle-active/', // + id
                        public: 'api/activitati/nomenclator/document-priorities/toggle-public/', // + id
                    },
                    documentTags: {
                        list: 'api/activitati/nomenclator/document-tags/list',
                        listDT: 'api/activitati/nomenclator/document-tags/list-dt',
                        listActive: 'api/activitati/nomenclator/document-tags/list-active',
                        listPublic: 'api/activitati/nomenclator/document-tags/list-public',
                        find: 'api/activitati/nomenclator/document-tags/find/', // + id
                        store: 'api/activitati/nomenclator/document-tags/store',
                        update: 'api/activitati/nomenclator/document-tags/update',  // id in payload
                        delete: 'api/activitati/nomenclator/document-tags/delete/', // + id
                        active: 'api/activitati/nomenclator/document-tags/toggle-active/', // + id
                        public: 'api/activitati/nomenclator/document-tags/toggle-public/', // + id
                    },
                    documentType: {
                        list: 'api/activitati/nomenclator/document-types/list',
                        listDT: 'api/activitati/nomenclator/document-types/list-dt',
                        listActive: 'api/activitati/nomenclator/document-types/list-active',
                        listPublic: 'api/activitati/nomenclator/document-types/list-public',
                        find: 'api/activitati/nomenclator/document-types/find/', // + id
                        store: 'api/activitati/nomenclator/document-types/store',
                        update: 'api/activitati/nomenclator/document-types/update',  // id in payload
                        delete: 'api/activitati/nomenclator/document-types/delete/', // + id
                        active: 'api/activitati/nomenclator/document-types/toggle-active/', // + id
                        public: 'api/activitati/nomenclator/document-types/toggle-public/', // + id
                    },
                    documentCategories: {
                        list: 'api/activitati/nomenclator/document-categories/list',
                        listDT: 'api/activitati/nomenclator/document-categories/list-dt',
                        listActive: 'api/activitati/nomenclator/document-categories/list-active',
                        listPublic: 'api/activitati/nomenclator/document-categories/list-public',
                        find: 'api/activitati/nomenclator/document-categories/find/', // + id
                        store: 'api/activitati/nomenclator/document-categories/store',
                        update: 'api/activitati/nomenclator/document-categories/update',  // id in payload
                        delete: 'api/activitati/nomenclator/document-categories/delete/', // + id
                        active: 'api/activitati/nomenclator/document-categories/toggle-active/', // + id
                        public: 'api/activitati/nomenclator/document-categories/toggle-public/', // + id
                        showEntities: 'api/activitati/nomenclator/document-categories/toggle-show-entities/', // + id
                        showContracts: 'api/activitati/nomenclator/document-categories/toggle-show-contracts/', // + id
                    },
                    documentSections: {
                        list: 'api/activitati/nomenclator/document-sections/list',
                        listDT: 'api/activitati/nomenclator/document-sections/list-dt',
                        listActive: 'api/activitati/nomenclator/document-sections/list-active',
                        listPublic: 'api/activitati/nomenclator/document-sections/list-public',
                        find: 'api/activitati/nomenclator/document-sections/find/', // + id
                        store: 'api/activitati/nomenclator/document-sections/store',
                        update: 'api/activitati/nomenclator/document-sections/update',  // id in payload
                        delete: 'api/activitati/nomenclator/document-sections/delete/', // + id
                        active: 'api/activitati/nomenclator/document-sections/toggle-active/', // + id
                        public: 'api/activitati/nomenclator/document-sections/toggle-public/', // + id
                    },
                    adreseCentre: {
                        list: 'api/activitati/nomenclator/adrese-centre/list',
                        listDT: 'api/activitati/nomenclator/adrese-centre/list-dt',
                        listActive: 'api/activitati/nomenclator/adrese-centre/list-active',
                        store: 'api/activitati/nomenclator/adrese-centre/store',
                        update: 'api/activitati/nomenclator/adrese-centre/update',  // id in payload
                        delete: 'api/activitati/nomenclator/adrese-centre/delete/', // + id
                        active: 'api/activitati/nomenclator/adrese-centre/update-active/', // + id
                    },
                    modul: {
                        list: 'api/activitati/nomenclator/module/list',
                        listDT: 'api/activitati/nomenclator/module/list-dt',
                        store: 'api/activitati/nomenclator/module/store',
                        update: 'api/activitati/nomenclator/module/update',
                        delete: 'api/activitati/nomenclator/module/delete/', // + id
                        listActive: 'api/activitati/nomenclator/module/list-active',
                        listPublic: 'api/activitati/nomenclator/module/list-public-view',
                        updateActive: 'api/activitati/nomenclator/module/update-active/', // + id
                        updatePublic: 'api/activitati/nomenclator/module/update-public-view/', // + id
                    },
                    locatii: {
                        list: 'api/activitati/nomenclator/locatii/list',
                        listDT: 'api/activitati/nomenclator/locatii/list-dt',
                        store: 'api/activitati/nomenclator/locatii/store',
                        update: 'api/activitati/nomenclator/locatii/update',
                        delete: 'api/activitati/nomenclator/locatii/delete/', // + id
                        listActive: 'api/activitati/nomenclator/locatii/list',
                        listPublic: 'api/activitati/nomenclator/locatii/list-public-view',
                        updateActive: 'api/activitati/nomenclator/locatii/update-active/', // + id
                        updatePublic: 'api/activitati/nomenclator/locatii/update-public-view/', // + id
                    },
                    specializari: {
                        list: 'api/activitati/nomenclator/specializari/list',
                        listDT: 'api/activitati/nomenclator/specializari/list-dt',
                        store: 'api/activitati/nomenclator/specializari/store',
                        update: 'api/activitati/nomenclator/specializari/update',
                        delete: 'api/activitati/nomenclator/specializari/delete/', // + id
                        listActive: 'api/activitati/nomenclator/specializari/list',
                        listPublic: 'api/activitati/nomenclator/specializari/list-public-view',
                        updateActive: 'api/activitati/nomenclator/specializari/update-active/', // + id
                        updatePublic: 'api/activitati/nomenclator/specializari/update-public-view/', // + id
                    },
                    operatori: {
                        list: 'api/activitati/nomenclator/operatori/simple-list-module-users',
                        listDT: 'api/activitati/nomenclator/operatori/list-module-users',
                        updateActive: 'api/activitati/nomenclator/operatori/update-active/', // + id
                        updatePublic: 'api/activitati/nomenclator/operatori/update-public-view/', // + id
                    },
                    zileLibere: {
                        list: 'api/activitati/nomenclator/zile/libere/list',
                        listDT: 'api/activitati/nomenclator/zile/libere/list-dt',
                        store: 'api/activitati/nomenclator/zile/libere/store',
                        update: 'api/activitati/nomenclator/zile/libere/update',
                        delete: 'api/activitati/nomenclator/zile/libere/delete/', // + id
                    },
                    tipuriProbleme: {
                        find: 'api/activitati/nomenclator/problem-type/find/', // + id
                        list: 'api/activitati/nomenclator/problem-type/list',
                        listDT: 'api/activitati/nomenclator/problem-type/list-dt',
                        store: 'api/activitati/nomenclator/problem-type/store',
                        update: 'api/activitati/nomenclator/problem-type/update',
                        delete: 'api/activitati/nomenclator/problem-type/delete/', // + id
                        listActive: 'api/activitati/nomenclator/problem-type/list-active',
                        listPublic: 'api/activitati/nomenclator/problem-type/list-public-view',
                        updateActive: 'api/activitati/nomenclator/problem-type/update-active/', // + id
                        updatePublic: 'api/activitati/nomenclator/problem-type/update-public-view/', // + id
                    },
                    program: {
                        listDT: 'api/activitati/nomenclator/program/list-dt',
                        store: 'api/activitati/nomenclator/program/store',
                        update: 'api/activitati/nomenclator/program/update',
                        delete: 'api/activitati/nomenclator/program/delete/', // + id
                        updateConfiguration: 'api/activitati/nomenclator/program/update-configuration/', // + id
                        updateSlots: 'api/activitati/nomenclator/program/update-slots/', // + id
                    },
                    sloturiBlocare: {
                        listDT: 'api/activitati/nomenclator/blocare-sloturi/list-dt',
                        store: 'api/activitati/nomenclator/blocare-sloturi/store',
                        update: 'api/activitati/nomenclator/blocare-sloturi/update',
                        delete: 'api/activitati/nomenclator/blocare-sloturi/delete/', // + id
                    },
                    status: {
                        find: 'api/activitati/nomenclator/status/find/', // + id
                        list: 'api/activitati/nomenclator/status/list',
                        listDT: 'api/activitati/nomenclator/status/list-dt',
                        store: 'api/activitati/nomenclator/status/store',
                        update: 'api/activitati/nomenclator/status/update',
                        delete: 'api/activitati/nomenclator/status/delete/', // + id
                        listActive: 'api/activitati/nomenclator/status/list/active',
                        listPublic: 'api/activitati/nomenclator/status/list/public',
                        updateActive: 'api/activitati/nomenclator/status/status/active/', // + id
                        updatePublic: 'api/activitati/nomenclator/status/status/public/', // + id
                        updateArchive: 'api/activitati/nomenclator/status/archive/', // + id
                        updateOrder: 'api/activitati/nomenclator/status/order/', // + id
                    },
                    prioritati: {
                        find: 'api/activitati/nomenclator/priorities/find/', // + id
                        list: 'api/activitati/nomenclator/priorities/list',
                        listDT: 'api/activitati/nomenclator/priorities/list-dt',
                        store: 'api/activitati/nomenclator/priorities/store',
                        update: 'api/activitati/nomenclator/priorities/update',
                        delete: 'api/activitati/nomenclator/priorities/delete/', // + id
                        listActive: 'api/activitati/nomenclator/priorities/list/active',
                        listPublic: 'api/activitati/nomenclator/priorities/list/public',
                        updateActive: 'api/activitati/nomenclator/priorities/status/active/', // + id
                        updatePublic: 'api/activitati/nomenclator/priorities/status/public/', // + id
                    },
                }
            },
            nomenclatoare: {
                directie: {
                    getDirectii: 'api/nomenclatoare/directie/list',
                    getDirectiiActive: 'api/nomenclatoare/directie/list/active',
                },
                compartiment: {
                    getCompartimente: 'api/nomenclatoare/directie-compartiment/list',
                    getCompartimenteByDirectie:
                        'api/nomenclatoare/directie-compartiment/listByDirectie/',
                    getCompartimenteActive:
                        'api/nomenclatoare/directie-compartiment/list/active',
                    // getCompartimenteByDgaspc: 'api/nomenclatoare/directie-compartiment/listByDirectieDgaspc',
                    getCompartimenteByDgaspc: 'api/nomenclatoare/directie-compartiment/listByDirectieUrbanism',
                },
                user: {
                    getUsers: 'api/nomenclatoare/user/list',
                    getActiveUsersByOrganigrama:
                        'api/nomenclatoare/user/list-users-organigrama',
                    getUsersList: 'api/nomenclatoare/user/list-all-users',
                },
                functiiUser: {
                    list: 'api/nomenclatoare/functie/list',
                    listActive: 'api/nomenclatoare/functie/list/active',
                },
                judet: {
                    list: 'api/nomenclatoare/auth-judet/list',
                    listActive: 'api/nomenclatoare/auth-judet/list/active',
                },
                cerereStatus: {
                    list: 'api/nomenclatoare/cerere-status/list',
                    listDT: 'api/nomenclatoare/cerere-status/list-dt',
                    listActive: 'api/nomenclatoare/cerere-status/list/active',
                    listPublic: 'api/nomenclatoare/cerere-status/list/public',
                    store: 'api/nomenclatoare/cerere-status/store',
                    update: 'api/nomenclatoare/cerere-status/update',  // id in payload
                    active: 'api/nomenclatoare/cerere-status/active/', // + id
                    public: 'api/nomenclatoare/cerere-status/public/', // + id
                    delete: 'api/nomenclatoare/cerere-status/delete/', // + id
                    archive: 'api/nomenclatoare/cerere-status/archive/', // + id
                    updateOrder: 'api/nomenclatoare/cerere-status/update-order/', // + id => put request
                    clearCache: 'api/nomenclatoare/cerere-status/clear-cache',
                    rankList: 'api/nomenclatoare/cerere-status/rank-list',
                },
                motiveRefuz: {
                    list: 'api/nomenclatoare/motive-refuz/list',
                    listDT: 'api/nomenclatoare/motive-refuz/list-dt',
                    store: 'api/nomenclatoare/motive-refuz/store',
                    update: 'api/nomenclatoare/motive-refuz/update/',  // + id
                    active: 'api/nomenclatoare/motive-refuz/toggle-active/', // + id
                    public: 'api/nomenclatoare/motive-refuz/toggle-public/', // + id
                    delete: 'api/nomenclatoare/motive-refuz/delete/', // + id
                },
                cererePriority: {
                    list: 'api/nomenclatoare/cerere-priority/list',
                    listDT: 'api/nomenclatoare/cerere-priority/list-dt',
                    listActive: 'api/nomenclatoare/cerere-priority/list/active',
                    listPublic: 'api/nomenclatoare/cerere-priority/list/public',
                    store: 'api/nomenclatoare/cerere-priority/store',
                    update: 'api/nomenclatoare/cerere-priority/update',  // id in payload
                    active: 'api/nomenclatoare/cerere-priority/active/', // + id
                    public: 'api/nomenclatoare/cerere-priority/public/', // + id
                    delete: 'api/nomenclatoare/cerere-priority/delete/', // + id
                    clearCache: 'api/nomenclatoare/cerere-priority/clear-cache',
                },
                cerereType: {
                    list: 'api/nomenclatoare/cerere-type/list', // + ?compartiment={value}
                    listDT: 'api/nomenclatoare/cerere-type/list-dt',
                    listActive: 'api/nomenclatoare/cerere-type/list/active',
                    listPublic: 'api/nomenclatoare/cerere-type/list/public',
                    store: 'api/nomenclatoare/cerere-type/store',
                    update: 'api/nomenclatoare/cerere-type/update',  // id in payload
                    active: 'api/nomenclatoare/cerere-type/active/', // + id
                    public: 'api/nomenclatoare/cerere-type/public/', // + id
                    delete: 'api/nomenclatoare/cerere-type/delete/', // + id
                    clearCache: 'api/nomenclatoare/cerere-type/clear-cache',
                },
                zileLibere: {
                    list: 'api/nomenclatoare/zile/libere/list',
                    listDT: 'api/nomenclatoare/zile/libere/list-dt',
                    store: 'api/nomenclatoare/zile/libere/store',
                    update: 'api/nomenclatoare/zile/libere/update',  // id in payload
                    delete: 'api/nomenclatoare/zile/libere/delete/', // + id
                },
                general: {
                    list: 'api/activitati/configuration/list',
                    update: 'api/activitati/configuration/update',
                    updateMultiple: 'api/activitati/configuration/multiple-configuration',
                    clearCache: 'api/activitati/configuration/clear-app-cache'
                },
                cerereDocumentType: {
                    list: 'api/nomenclatoare/document-types/list',
                    listDT: 'api/nomenclatoare/document-types/list-dt',
                    find: 'api/nomenclatoare/document-types/find/', // + id
                    store: 'api/nomenclatoare/document-types/store',
                    update: 'api/nomenclatoare/document-types/update',  // id in payload
                    delete: 'api/nomenclatoare/document-types/delete/', // + id
                    clearCache: 'api/nomenclatoare/document-types/clear-cache',
                },
                cerereDocumentCategory: {
                    list: 'api/nomenclatoare/document-categories/list',
                    listDT: 'api/nomenclatoare/document-categories/list-dt',
                    find: 'api/nomenclatoare/document-categories/find/', // + id
                    store: 'api/nomenclatoare/document-categories/store',
                    update: 'api/nomenclatoare/document-categories/update',  // id in payload
                    delete: 'api/nomenclatoare/document-categories/delete/', // + id
                    clearCache: 'api/nomenclatoare/document-categories/clear-cache',
                },
                crons: {
                    list: 'api/nomenclatoare/cron/list',
                    listDT: 'api/nomenclatoare/cron/list-dt',
                    listActive: 'api/nomenclatoare/cron/list-active',
                    store: 'api/nomenclatoare/cron/store',
                    update: 'api/nomenclatoare/cron/update',  // id in payload
                    changeStatus: 'api/nomenclatoare/cron/change-status/', // + id
                    delete: 'api/nomenclatoare/cron/delete/', // + id
                },
                configurations: {
                    listDT: 'api/settings/configuration/list-dt',
                    find: 'api/settings/configuration/find/', // + field_key
                    one: 'api/settings/configuration/one/',   // + id
                    store: 'api/settings/configuration/store',
                    update: 'api/settings/configuration/update', // id in payload
                },
                imageType: {
                    list: 'api/nomenclatoare/image-type/list',
                    listDT: 'api/nomenclatoare/image-type/list-dt',
                    find: 'api/nomenclatoare/image-type/find/', // + id
                    store: 'api/nomenclatoare/image-type/store',
                    update: 'api/nomenclatoare/image-type/update',  // id in payload
                    delete: 'api/nomenclatoare/image-type/delete/', // + id
                },
                cerereSabloane: {
                    list: 'api/nomenclatoare/cerere-sabloane/list',
                    listDT: 'api/nomenclatoare/cerere-sabloane/list-dt',
                    listActive: 'api/nomenclatoare/cerere-sabloane/list/active',
                    listPublic: 'api/nomenclatoare/cerere-sabloane/list/public',
                    store: 'api/nomenclatoare/cerere-sabloane/store',
                    update: 'api/nomenclatoare/cerere-sabloane/update',  // id in payload
                    active: 'api/nomenclatoare/cerere-sabloane/active/', // + id
                    public: 'api/nomenclatoare/cerere-sabloane/public/', // + id
                    delete: 'api/nomenclatoare/cerere-sabloane/delete/', // + id
                },
                operatori: {
                    listDT: 'api/nomenclatoare/user/list-module-users',
                    getOperatorPermisiuniList: 'api/settings/operatori/operator-cereri-permissions-list/', // + id
                    updateOperatorPermisiuni: 'api/settings/operatori/update-cereri-permissions/', // + id
                    getOperatorFunctie: 'api/settings/operatori/operator-cereri-functie/', // + user_id
                    updateOperatorFunctie: 'api/settings/operatori/operator-cereri-functie-update/', // user_id, payload {functie_id}
                    getOperatoriByCompartiment: 'api/settings/operatori/operator-compartment-list/', // + id_compartiment
                    getOperatorAccess: 'api/nomenclatoare/user/get-operator-access', // get user by token
                    operatorAccessList: 'api/nomenclatoare/user/operator-access-list',
                    operatorAccessListDt: 'api/nomenclatoare/user/operator-access-list-dt', // id_user in payload list-dt
                    allocateOperatorAccess: 'api/nomenclatoare/user/allocate-operator-access', // id_user in payload
                    deleteOperatorAccess: 'api/nomenclatoare/user/delete-operator-access/', // + id_access
                    activeOperatorAccess: 'api/nomenclatoare/user/active-operator-access/', // + id_access

                    // Multi-function endpoints
                    getUserMultipleFunctii: 'api/settings/operatori/operator-cereri-functii-multiple/', // + user_id
                    updateUserMultipleFunctii: 'api/settings/operatori/operator-cereri-functii-multiple-update/', // + user_id
                    setActiveFunctie: 'api/settings/operatori/operator-cereri-functie-set-active/', // + user_id
                    getActiveFunctie: 'api/settings/operatori/operator-cereri-functie-active/', // + user_id
                    getUserFunctiiList: 'api/settings/operatori/operator-cereri-functii-list/', // + user_id
                    userHasFunctions: 'api/settings/operatori/operator-has-functions/', // + user_id

                    // Enhanced features endpoints
                    functieHistory: 'api/settings/operatori/functie-history/', // + user_id
                    functieHistoryExport: 'api/settings/operatori/functie-history-export/', // + user_id
                    functieHistoryStatistics: 'api/settings/operatori/functie-history-statistics',
                    recentFunctionChanges: 'api/settings/operatori/recent-function-changes',
                    bulkAssignmentUsers: 'api/settings/operatori/bulk-assignment/users',
                    bulkAssignmentPreview: 'api/settings/operatori/bulk-assignment/preview',
                    bulkAssignmentExecute: 'api/settings/operatori/bulk-assignment/execute',
                    bulkAssignmentHistory: 'api/settings/operatori/bulk-assignment/history',
                    bulkAssignmentTemplates: 'api/settings/operatori/bulk-assignment/templates',
                },
                documentTemplate: {
                    list: 'api/nomenclatoare/document-templates/list',
                    listDT: 'api/nomenclatoare/document-templates/list-dt',
                    one: 'api/nomenclatoare/document-templates/find/', // + id
                    templateById: 'api/cerere/get-official-doc-template/',
                    store: 'api/nomenclatoare/document-templates/store',
                    update: 'api/nomenclatoare/document-templates/update', // id in payload
                    active: 'api/nomenclatoare/document-templates/updateStatusActive/', // + id
                    delete: 'api/nomenclatoare/document-templates/delete/', // + id
                    previewDocument: 'api/nomenclatoare/document-templates/preview/', // + type/id
                    signatures: {
                        getListIds:
                            'api/nomenclatoare/document-templates/signatures/allocated/', // + id template
                        updateIds:
                            'api/nomenclatoare/document-templates/signatures/allocated/', // + id template
                        updateOrder:
                            'api/nomenclatoare/document-templates/signatures/update-order/', // + id signature
                        updateSignType:
                            'api/nomenclatoare/document-templates/signatures/update-sign-type/', // + id
                        updateSignatures:
                            'api/nomenclatoare/document-templates/signatures/update-signatures',
                    },
                    filters: {
                        list: 'api/nomenclatoare/document-templates/filters/list',
                        registry: 'api/nomenclatoare/document-templates/filters/registry',
                        drafts: 'api/nomenclatoare/document-templates/filters/drafts',
                        addressTypes: 'api/nomenclatoare/document-templates/filters/address-types',
                        categories: 'api/nomenclatoare/document-templates/filters/categories',
                        categorySearch: 'api/nomenclatoare/document-templates/filters/category-search',
                        options: 'api/nomenclatoare/document-templates/filters/options',
                        categoriesSearch: 'api/nomenclatoare/document-templates/filters/categories/search',
                        stats: 'api/nomenclatoare/document-templates/filters/stats',
                    },
                    clone: {
                        duplicate: 'api/nomenclatoare/document-templates/clone/duplicate/', // + id
                        validateName: 'api/nomenclatoare/document-templates/clone/validate-name',
                        preview: 'api/nomenclatoare/document-templates/clone/preview',
                        targetGroups: 'api/nomenclatoare/document-templates/clone/target-groups',
                        documentTemplate: 'api/nomenclatoare/document-templates/clone/document-template/', // + templateId
                        smartGroup: 'api/nomenclatoare/document-templates/clone/smart-template-group/', // + groupId
                        toSmartPart: 'api/nomenclatoare/document-templates/clone/to-smart-part',
                    },
                },
                smartTemplates: {
                    groups: {
                        list: 'api/nomenclatoare/smart-templates/groups/list',
                        listDT: 'api/nomenclatoare/smart-templates/groups/list-dt',
                        one: 'api/nomenclatoare/smart-templates/groups/find/', // + id
                        store: 'api/nomenclatoare/smart-templates/groups/store',
                        update: 'api/nomenclatoare/smart-templates/groups/update/', // + id
                        delete: 'api/nomenclatoare/smart-templates/groups/delete/', // + id
                        active: 'api/nomenclatoare/smart-templates/groups/toggle-active/', // + id
                        public: 'api/nomenclatoare/smart-templates/groups/toggle-public/', // + id
                    },
                    parts: {
                        list: 'api/nomenclatoare/smart-templates/parts/list',
                        listDT: 'api/nomenclatoare/smart-templates/parts/list-dt',
                        one: 'api/nomenclatoare/smart-templates/parts/find/', // + id
                        store: 'api/nomenclatoare/smart-templates/parts/store',
                        update: 'api/nomenclatoare/smart-templates/parts/update/', // + id
                        delete: 'api/nomenclatoare/smart-templates/parts/delete/', // + id
                        active: 'api/nomenclatoare/smart-templates/parts/toggle-active/', // + id
                        public: 'api/nomenclatoare/smart-templates/parts/toggle-public/', // + id
                    },
                    parameters: {
                        list: 'api/nomenclatoare/smart-templates/parameters/list',
                        listDT: 'api/nomenclatoare/smart-templates/parameters/list-dt',
                        one: 'api/nomenclatoare/smart-templates/parameters/find/', // + id
                        store: 'api/nomenclatoare/smart-templates/parameters/store',
                        update: 'api/nomenclatoare/smart-templates/parameters/update/', // + id
                        delete: 'api/nomenclatoare/smart-templates/parameters/delete/', // + id
                        bulk: 'api/nomenclatoare/smart-templates/parameters/bulk',
                    },
                    categories: 'api/nomenclatoare/smart-templates/categories',
                    availableParts: 'api/nomenclatoare/smart-templates/available-parts',
                    generate: 'api/nomenclatoare/smart-templates/generate',
                    preview: 'api/nomenclatoare/smart-templates/preview',
                    validate: 'api/nomenclatoare/smart-templates/validate',
                    export: 'api/nomenclatoare/smart-templates/export',
                    import: 'api/nomenclatoare/smart-templates/import',
                    stats: 'api/nomenclatoare/smart-templates/stats',
                    assignments: {
                        list: 'api/nomenclatoare/smart-templates/assignments/list',
                        byDocumentType: 'api/nomenclatoare/smart-templates/assignments/document-type/', // + documentTypeId
                        save: 'api/nomenclatoare/smart-templates/assignments/save',
                        delete: 'api/nomenclatoare/smart-templates/assignments/delete/', // + assignmentId
                    },
                },
                documentTypes: {
                    list: 'api/nomenclatoare/document-types/list',
                    byCategory: 'api/nomenclatoare/document-types/by-category/', // + categoryId
                    getDocumenteTypesIndoc: 'api/nomenclatoare/document-types/list/indoc',
                    getIndocCategorii: 'api/nomenclatoare/document-types/list-categories/indoc',
                    getIndocSource: 'api/nomenclatoare/document-types/list-sources/indoc'
                },
                registre: {
                    list: 'api/document-oficial-registru/list',
                    listDT: 'api/document-oficial-registru/list-dt',
                    listActive: 'api/document-oficial-registru/list/active',
                    listPublic: 'api/document-oficial-registru/list/public',
                    store: 'api/document-oficial-registru/store',
                    update: 'api/document-oficial-registru/update',
                    updateSequence: 'api/document-oficial-registru/update-sequance/',
                    active: 'api/document-oficial-registru/active/',
                    public: 'api/document-oficial-registru/public/',
                    delete: 'api/document-oficial-registru/delete/',
                    find: 'api/document-oficial-registru/find/',
                    getIndocSerii: 'api/document-oficial-registru/list/indoc',
                },
                registru: {
                    list: 'api/registru/list',
                    listDT: 'api/registru/list-dt',
                    storeDocumentOficial: 'api/registru/document-oficial-add/', // + registru type id,
                    editDocumentOficial: 'api/registru/document-oficial-edit/', // + registru type id,
                    exportRegister: 'api/registru/export',
                    exportCSVRegister: 'api/registru/export-csv',
                },
            },
        },
        indocCore: {
            linkRedirectIndoc: 'https://local.indoc.webproductionlabs.com/',
        },
        authCore: {
            basePath: 'https://development.auth-core.webproductionlabs.com/',
            linkRedirectAuth: 'https://development.app.webproductionlabs.com/#/aplicatii',
            platform: {
                getUserDetails: 'api/user/1/1', // get user from token and also validate token for operator to autorize actions
                getUserPermissionsAuthLib:
                    'api/client/module/permission/user/getUserPermissionsAuthLib/',
            },
        },
    },
};

/*
 *  To run this proper configuration, please use: ng serve
 */
